import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';


const Page5IncidencesFinancieresHypPart2 = (props) =>
{
    const blue = '#069BD3';
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;

    const [incidencesData, setIncidencesData] = useState(null);

    async function getDatas() {
        // Convertir le numéro d'hypothèse en clé (1 -> h1, 2 -> h2, 3 -> h3)
        const hypotheseMap = { 1: 'h1', 2: 'h2', 3: 'h3' };
        const hypotheseKey = hypotheseMap[props.hypothese];
        const annee_debut = props.user.config_budget.retro_an_deb;
        const annee_fin = props.user.config_budget.prosp_an_fin;

        if (annee_debut === undefined || annee_fin === undefined) {
            console.warn('Les années de début et de fin ne sont pas définies dans la configuration du budget utilisateur.');
            return;
        }

        try {
            const response = await axios.post('https://app-slfinance.fr/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_consolidated_by_budget_hypothesis_and_years',
                id_budget: props.user.id_budget,
                hypothese: hypotheseKey,
                annee_debut: annee_debut,
                annee_fin: annee_fin
            }));

            if (response.data.status === 1) {
                setIncidencesData(response.data.data);
            } else {
                console.warn('Erreur API:', response.data.message);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des incidences financières:', error);
        }
    }

    // UseEffect pour recuperer les incidences financieres en fonction de props.hypothese.
    useEffect(() => {
        if (props.hypothese !== null && props.user) {
            getDatas();
        }
    }, [props.hypothese, props.user]);

    const fieldsList = [
        { label: 'Entretien réparations [ER]', key: 'sum_entretien_reparations', compte: '615', isBold: false, isCalculated: false },
        { label: 'Eau/électricité [DEE]', key: 'sum_eau_electricite', compte: '6061', isBold: false, isCalculated: false },
        { label: 'Charges de copro. [DCC]', key: 'sum_charges_copropriete', compte: '614', isBold: false, isCalculated: false },
        { label: 'Taxes foncières [DTFB]', key: 'sum_taxes_foncieres', compte: '6351', isBold: false, isCalculated: false },
        { label: 'Taxe/redevance OM [DOM]', key: 'sum_taxe_redevance_om', compte: '6351', isBold: false, isCalculated: false },
        { label: 'Assurances [DASS]', key: 'sum_assurances', compte: '616', isBold: false, isCalculated: false },
        { label: 'Autres [DAU]', key: 'sum_autres_depenses', compte: '618', isBold: false, isCalculated: false },
        { label: 'TOTAL Dépenses [TOTDEP]', key: 'sum_total_depenses', isBold: true, isCalculated: true },
        { label: '', key: 'empty_5', isEmpty: true },
        { label: 'Loyers perçus [LOY]', key: 'sum_loyers_percus', compte: '7083', isBold: false, isCalculated: false },
        { label: 'Refacturation - Eau/électricité [REE]', key: 'sum_refacturation_eau_electricite', compte: '7087', isBold: false, isCalculated: false },
        { label: 'Refacturation - Charges de copro. [RCC]', key: 'sum_refacturation_charges_copropriete', compte: '7087', isBold: false, isCalculated: false },
        { label: 'Refacturation - Taxes foncières [RTFB]', key: 'sum_refacturation_taxes_foncieres', compte: '7087', isBold: false, isCalculated: false },
        { label: 'Refacturation - OM [ROM]', key: 'sum_refacturation_om', compte: '7087', isBold: false, isCalculated: false },
        { label: 'Refacturation - Assurances [RASS]', key: 'sum_refacturation_assurances', compte: '7087', isBold: false, isCalculated: false },
        { label: 'Autres [RAU]', key: 'sum_autres_recettes', compte: '7088', isBold: false, isCalculated: false },
        { label: 'TOTAL Recettes [TOTREC]', key: 'sum_total_recettes', isBold: true, isCalculated: true },
        { label: '', key: 'empty_6', isEmpty: true },
        { label: 'Solde annuel frais de gestion [SAFG]', key: 'sum_solde_annuel_frais_gestion', isBold: false, isCalculated: true },
        { label: 'Solde cumulé frais de gestion [SCFG]', key: 'sum_solde_cumule_frais_gestion', isBold: false, isCalculated: true },
        { label: '', key: 'empty_7', isEmpty: true },
        { label: 'Solde d\'opération fin d\'année [SO]', key: 'sum_solde_operation', isBold: true, isCalculated: true }
    ];

    const formatNumber = (value) => {
        if (!value || isNaN(value)) return '';
        const num = parseFloat(value);
        return num.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const filteredIncidencesData = incidencesData || [];


    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Incidences financières</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.hypothese !== null ? '(hypothèse '+props.hypothese+')' : ''} - partie 2</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, padding: '0 15px', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                {filteredIncidencesData && filteredIncidencesData.length > 0 ? (
                    <div style={{width: '100%', overflowX: 'auto', overflowY: 'auto', flex: 1, borderRadius: '6px', border: '1px solid #ddd', marginTop: '8px', position: 'relative', minWidth: 0}}>
                        <div style={{display: 'flex', minWidth: 'min-content', height: '100%'}}>
                            {/* Colonne Catégorie */}
                            <div style={{width: 40, minWidth: 40, backgroundColor: 'transparent', display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', flexShrink: 0}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}></div>

                                {/* Dépenses - 8 lignes */}
                                <div style={{flex: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>
                                        Dépenses
                                    </div>
                                </div>

                                <div style={{flex: 0.5, display: 'flex'}}></div>

                                {/* Recettes - 8 lignes */}
                                <div style={{flex: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', borderRight: '1px solid #ccc', borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                                    <div style={{transform: 'rotate(-90deg)', transformOrigin: 'center', whiteSpace: 'nowrap', fontSize: 12, fontWeight: 'bold', color: '#666'}}>
                                        Recettes
                                    </div>
                                </div>

                                <div style={{flex: 4, display: 'flex'}}></div>
                            </div>

                            {/* Colonne Figée - Libellés */}
                            <div style={{minWidth: 200, maxWidth: 300, backgroundColor: 'transparent', flexShrink: 0, display: 'flex', flexDirection: 'column'}}>
                                {/* Header */}
                                <div style={{display: 'flex', flex: 1, alignItems: 'center', padding: '0 10px', backgroundColor: blue, fontWeight: 'bold', position: 'sticky', left: 0, top: 0, zIndex: 12}}>
                                    <p style={{color: 'white', margin: 0, fontSize: fontsize-1}}>Libellé (en euro)</p>
                                </div>

                                {/* Lignes */}
                                {fieldsList.map((row, idx) => (
                                    <div key={idx} style={{display: 'flex', flex: row.isEmpty ? 0.5 : 1, alignItems: 'center', padding: '0 8px', borderBottom: '1px solid #ddd', backgroundColor: row.isEmpty ? 'transparent' : (row.isCalculated ? '#f0f0f0' : '#ffffff'), position: 'sticky', left: 0, zIndex: 11}}>
                                        <p style={{fontSize: fontsize, fontWeight: row.isBold ? 'bold' : 'normal', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{row.compte && (<><span style={{color: 'red'}}>{row.compte}</span>{' - '}</>)}{row.label}</p>
                                    </div>
                                ))}
                            </div>

                            {/* Colonnes de données (années) */}
                            <div style={{display: 'flex', flex: 1}}>
                                {filteredIncidencesData.map((row, yearIdx) => (
                                    <div key={yearIdx} style={{flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                        {/* Header année */}
                                        <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', padding: '0 3px', backgroundColor: blue, fontWeight: 'bold', borderBottom: '1px solid #ddd', position: 'sticky', top: 0, zIndex: 10}}>
                                            <p style={{color: 'white', margin: 0, fontSize: fontsize-2}}>
                                                {row.annee}
                                            </p>
                                        </div>

                                        {/* Données lignes */}
                                        {fieldsList.map((rowDef, idx) => {
                                            const displayValue = row[rowDef.key];
                                            
                                            const isZeroOrEmpty = (val) => {
                                                if (!val || val === '') return true;
                                                const parsed = parseFloat(String(val).replace(',', '.'));
                                                return isNaN(parsed) || parsed === 0;
                                            };

                                            return (
                                                <div key={idx} style={{display: 'flex', flex: rowDef.isEmpty ? 0.5 : 1, borderBottom: '1px solid #ccc', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isEmpty ? 'transparent' : '#ffffff'}}>
                                                    {rowDef.isEmpty ? (
                                                        <div></div>
                                                    ) : isZeroOrEmpty(displayValue) ? (
                                                        <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: rowDef.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: rowDef.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                            &nbsp;
                                                        </div>
                                                    ) : (
                                                        <div style={{width: '100%', height: '100%', fontSize: fontsize-1, textAlign: 'center', fontWeight: rowDef.isBold ? 700 : 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: rowDef.isCalculated ? '#f0f0f0' : '#ffffff', borderLeft: '1px solid #ddd', color: rowDef.isBold ? '#000' : '#666', padding: '0 2px'}}>
                                                            {formatNumber(displayValue)}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                        <p style={{color: '#999', fontSize: fontsize}}>Aucune donnée disponible</p>
                    </div>
                )}
            </div>

            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page5IncidencesFinancieresHypPart2;
